import { CIP_SHORT_ALIASES } from "../data/CIP_SHORT_ALIASES";
// your existing truncate function
/**
 * truncate() – shortens a string if over maxLength, and appends "…".
 * E.g. truncate("InternationalEconomics", 10) => "Internation…"
 */
function truncate(str, maxLength = 12) {
    if (!str) return "";
    return str.length > maxLength
      ? str.slice(0, maxLength - 1) + "…"
      : str;
  }
  
/**
 * shortenCipName(cipCode, cipName, maxLen = 20)
 * 1) If CIP_SHORT_ALIASES[cipCode] exists, return that alias.
 * 2) Otherwise, truncate CIP name to maxLen.
 */
export function shortenCipName(cipCode, cipName, maxLen = 20) {
  if (!cipName) return 'NA';

  if (CIP_SHORT_ALIASES[cipCode]) {
    return CIP_SHORT_ALIASES[cipCode];
  }

  return truncate(cipName, maxLen);
}